export default __webpack_public_path__ + "static/media/telecom.7049ec10.jpg";